import { Stack, Text, VStack } from '@chakra-ui/react';
import React from 'react';
import Sidebar from './Sidebar/Sidebar';
import {Outlet}  from 'react-router-dom';
import Menubar from './Menubar/Menubar';
const Dashboard = () => {
    return (
        <VStack display="flex" flexDirection="row" w="100%" alignItems="start" justifyContent="space-between">
            <Stack w="380px">
                {/* Sidebar */}
                <Sidebar/>
            </Stack>
            <Stack  width="75%" paddingLeft="25px" marginRight="auto">
                <Menubar/>
                <Outlet />
            </Stack>
        </VStack>
    );
};

export default Dashboard;